<template>
  <el-dialog
    :model-value="visible"
    title="提交反馈"
    :width="dialogWidth"
    class="user-feedback-submit-dialog"
    :class="{ 'user-feedback-submit-dialog--mobile': isMobile }"
    :align-center="!isMobile"
    destroy-on-close
    @update:model-value="onVisibleChange"
    @closed="$emit('close')"
  >
    <el-form
      ref="formRef"
      class="user-feedback-submit-form"
      :model="form"
      :rules="rules"
      label-position="top"
      require-asterisk-position="left"
    >
      <el-form-item label="反馈类型" prop="type">
        <el-radio-group v-model="form.type">
          <el-radio value="BUG">缺陷反馈</el-radio>
          <el-radio value="SUGGESTION">功能建议</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="反馈内容" prop="content">
        <el-input
          v-model="form.content"
          type="textarea"
          :rows="textareaRows"
          maxlength="2000"
          show-word-limit
          placeholder="请描述你遇到的问题或建议"
        />
      </el-form-item>
    </el-form>
    <template #footer>
      <el-button @click="$emit('close')">取消</el-button>
      <el-button
        type="primary"
        :loading="loading"
        @click="$emit('submit', formRef)"
      >
        提交
      </el-button>
    </template>
  </el-dialog>
</template>

<script setup>
import { computed, onBeforeUnmount, onMounted, ref } from 'vue'
import { isMobileLayoutViewport } from '@/shared/utils/mobileLayout'

defineProps({
  visible: { type: Boolean, default: false },
  form: { type: Object, required: true },
  rules: { type: Object, required: true },
  loading: { type: Boolean, default: false },
})

const emit = defineEmits(['update:visible', 'close', 'submit'])

const formRef = ref(null)
const isMobile = ref(false)

const dialogWidth = computed(() => (isMobile.value ? '88%' : '28rem'))
const textareaRows = computed(() => (isMobile.value ? 3 : 6))

function updateIsMobile() {
  isMobile.value = isMobileLayoutViewport()
}

/**
 * @param {boolean} value
 */
function onVisibleChange(value) {
  emit('update:visible', value)
  if (!value) emit('close')
}

onMounted(() => {
  updateIsMobile()
  window.addEventListener('resize', updateIsMobile)
})

onBeforeUnmount(() => {
  window.removeEventListener('resize', updateIsMobile)
})
</script>

<!-- el-dialog teleport 到 body，scoped 选不中表单项，需非 scoped -->
<style src="@/features/user/styles/operationArea/UserFeedbackSubmitDialog.css"></style>
